/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */

/**
 * Reviewer decision on the submitted KYC record
 */
export type ReviewKycDtoDecision = typeof ReviewKycDtoDecision[keyof typeof ReviewKycDtoDecision];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewKycDtoDecision = {
  verified: 'verified',
  rejected: 'rejected',
} as const;
